import Login from './Login';
import Register from './Register';
import RecoverPassword from './RecoverPassword';

export { Login, Register, RecoverPassword };



// WEBPACK FOOTER //
// ./src/pages/Auth/index.js